<template>
  <div :class="[inline ? 'slideForm-inline' : 'slideForm']">
    <div class="slideForm-main">
      <slot></slot>
    </div>
    <div class="slideForm-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slideForm',
  props: {
    inline: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="less">
.slideForm {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  padding: 6px;
  .slideForm-main {
    display: flex;
    flex: 1;
    flex-basis: auto;
    overflow: auto;
    box-sizing: border-box;
    ::v-deep .el-form {
      height: 100%;
      .el-form-item {
        position: relative;
        margin: 18px 0 0;
        .el-form-item__label {
          position: absolute;
          z-index: 2;
          top: -12px;
          margin-left: 10px;
          padding: 0 6px;
          line-height: normal;
          background-color: #fff;
          color: #000;
        }
      }
      .el-scrollbar {
        height: 100%;
      }
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
      .el-scrollbar__bar {
        z-index: 999;
      }
    }
  }
  .slideForm-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;
  }
}
.slideForm-inline {
  display: flex;
  justify-content: space-between;
  ::v-deep .el-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>